import { VideoUpload } from '@/components/VideoUpload';
import { Button } from '@/components/ui/button';
import { Zap, Wand2, Mic, Smile } from 'lucide-react';

export default function Landing() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      {/* Header */}
      <header className="border-b border-white/10 backdrop-blur-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Zap className="w-6 h-6 text-cyan-400" />
            <span className="text-xl font-bold text-white">VideoMaster</span>
          </div>
          <Button variant="outline" className="text-white border-white/20 hover:bg-white/10">
            Sign In
          </Button>
        </div>
      </header>

      {/* Hero Section */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="text-center mb-16">
          <h1 className="text-5xl sm:text-6xl font-bold text-white mb-6 leading-tight">
            Professional Video Editing
            <span className="bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent">
              {' '}Powered by AI
            </span>
          </h1>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Edit, clone, generate, and transform videos with AI-powered voice changing and lip-sync technology
          </p>
        </div>

        {/* Upload Section */}
        <div className="bg-white/5 backdrop-blur border border-white/10 rounded-2xl p-8 mb-16">
          <VideoUpload />
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-20">
          {[
            {
              icon: Wand2,
              title: 'Smart Editing',
              desc: 'Cut, trim, and enhance videos with AI assistance'
            },
            {
              icon: Mic,
              title: 'Voice Changing',
              desc: 'Change voices with natural-sounding AI models'
            },
            {
              icon: Smile,
              title: 'Lip Sync',
              desc: 'Perfect lip-sync matching with any audio'
            },
            {
              icon: Zap,
              title: 'Clone & Generate',
              desc: 'Create variations and clone video content'
            }
          ].map((feature, i) => {
            const Icon = feature.icon;
            return (
              <div
                key={i}
                className="bg-white/5 backdrop-blur border border-white/10 rounded-xl p-6 hover:bg-white/10 transition-all"
              >
                <Icon className="w-8 h-8 text-cyan-400 mb-4" />
                <h3 className="font-semibold text-white mb-2">{feature.title}</h3>
                <p className="text-sm text-gray-400">{feature.desc}</p>
              </div>
            );
          })}
        </div>

        {/* CTA Section */}
        <div className="text-center">
          <div className="bg-gradient-to-r from-cyan-400/20 to-blue-500/20 border border-cyan-400/30 rounded-xl p-8">
            <h2 className="text-2xl font-bold text-white mb-4">
              Ready to transform your videos?
            </h2>
            <p className="text-gray-400 mb-6">
              Upload your video above to get started with professional editing
            </p>
            <Button size="lg" className="bg-cyan-500 hover:bg-cyan-600 text-white">
              Get Started Free
            </Button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t border-white/10 mt-20 py-8 text-center text-gray-400">
        <p>&copy; 2024 VideoMaster. Professional video editing for everyone.</p>
      </footer>
    </div>
  );
}
